export const treatments = [
  {
    value: 'standard',
    name: 'Standard cohort of donor eggs',
    description: '1 egg lot: 6-8 frozen donor eggs',
    cost: 19190,
    addons: [
      {
        value: 'shipping',
        name: 'Would you like to include shipping costs in finance estimate?',
        cost: 690
      }
    ]
  },
  {
    value: '3Cohort',
    name: '3 Cohort Package',
    description: '3 egg lots: 18-24 frozen donor eggs',
    cost: 44100,
    addons: [
      {
        value: 'shipping',
        name: 'Would you like to include shipping costs in finance estimate?',
        cost: 690
      }
    ]
  }
];
